var A = /* @__PURE__ */ ((a) => (a.VARIANT_A = "contact-person--variant-a", a.VARIANT_A_WITHOUT_IMAGE = "contact-person--variant-a-without-image", a.VARIANT_B = "contact-person--variant-b", a))(A || {});
export {
  A as RocheUIContactPersonLayout
};
